import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import './ModifyDeckModal.css';

import { PropTypesCustom } from '../../../libs/helper';
import ModalBase from '../ModalBase';
import SimpleInput from '../../SimpleComponents/SimpleInput';
import SimpleTextarea from '../../SimpleComponents/SimpleTextarea';
import SimpleButton, { ButtonsWrapper, ButtonTypes } from '../../SimpleComponents/SimpleButton';

const modifyDeckModalStyles = {
	content: {
		width: '350px',
	},
};

const max_name_length = 250;
const max_note_length = 1000;

/**
 * Modify deck parameters modal
 * @component
 */
const ModifyDeckModal = ({ isOpen, title, deck, onResult }) => {
	const [nameValue, setNameValue] = useState('');
	const [noteValue, setNoteValue] = useState('');

	useEffect(() => {
		console.log('Init ModifyDeckModal');
	}, []);

	useEffect(() => {
		if (deck) {
			setNameValue(deck.name);
			setNoteValue(deck.note);
		} else {
			setNameValue('');
			setNoteValue('');
		}
	}, [deck]);

	return (
		<ModalBase
			className="modal-modify-deck"
			isOpen={isOpen}
			style={modifyDeckModalStyles}
			onRequestClose={handleCancel}
		>
			<div className="modal-header">
				<div className="modal-title">{title}</div>
				<div className="modal-close-x" onClick={handleCancel} />
			</div>

			<div className="modal-content">
				<SimpleInput
					autoFocus={true}
					limit={max_name_length}
					placeholder="Deck name"
					tabIndex={1}
					title="Deck name"
					value={nameValue}
					onChange={handleChangeNameValue}
					onKeyDown={handleKeyDown}
				/>
				<SimpleTextarea
					className="deck-notes"
					limit={max_note_length}
					placeholder="Any notes if required…"
					title="Deck notes"
					value={noteValue}
					onChange={handleChangeNote}
					onKeyDown={handleKeyDown}
				/>
			</div>
			<div className="modal-control">
				<ButtonsWrapper>
					<SimpleButton title="Save storage" type={ButtonTypes.DEFAULT} value="Save" onClick={handleSave} />
					<SimpleButton title="Close" type={ButtonTypes.GREY} value="Close" onClick={handleCancel} />
				</ButtonsWrapper>
			</div>
		</ModalBase>
	);

	// Reset input to defaults
	function reset() {
		setNameValue('');
		setNoteValue('');
	}

	// Cancel changes
	function handleCancel() {
		onResult({
			status: false,
		});
		reset();
	}

	// Apply changes
	function handleSave() {
		onResult({
			status: true,
			data: {
				name: nameValue,
				note: noteValue,
			},
		});
	}

	function handleChangeNameValue(event) {
		const value = event.target.value.substring(0, max_name_length);
		setNameValue(value);
	}

	function handleChangeNote(event) {
		const value = event.target.value.substring(0, max_note_length);
		setNoteValue(value);
	}

	// Process Enter key
	function handleKeyDown(event) {
		if (event.key === 'Enter') {
			handleSave();
			event.preventDefault();
		}
	}
};

ModifyDeckModal.propTypes = {
	// Open state of modal
	isOpen: PropTypes.bool.isRequired,
	// Modal title
	title: PropTypes.string.isRequired,
	// Deck object (or null)
	deck: PropTypesCustom.object_or_null_required,
	// Callback function on submit
	onResult: PropTypes.func.isRequired,
};

export default ModifyDeckModal;
